import { render, staticRenderFns } from "./ClientUserCard.vue?vue&type=template&id=64bcc10a&"
import script from "./ClientUserCard.vue?vue&type=script&lang=js&"
export * from "./ClientUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports